import { type PropsWithChildren, useCallback } from "react";

type FormProps = PropsWithChildren<{
    onSubmit: () => unknown;
}>;

export default function Form(props: FormProps) {
    const { onSubmit } = props;

    const onSubmitEvent = useCallback(
        (e: React.SubmitEvent<HTMLFormElement>) => {
            e.preventDefault();
            onSubmit();
        },
        [onSubmit],
    );
    return <form onSubmit={onSubmitEvent}>{props.children}</form>;
}
